import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';

const getScoreColor = (score) => {
  if (score >= 80) return '#1E3A8A';
  if (score >= 60) return '#3b82f6';
  if (score >= 40) return '#f59e0b';
  return '#ef4444';
};

function ScoreRing({ score = 0, size = 80, strokeWidth = 7, label = '' }) {
  const radius = (size - strokeWidth * 2) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(score, 100) / 100) * circumference;
  const color = getScoreColor(score);
  const cx = size / 2;
  const cy = size / 2;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <Box sx={{ position: 'relative', width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', display: 'block' }}>
          <circle cx={cx} cy={cy} r={radius} fill="none" stroke="#f0f4f8" strokeWidth={strokeWidth} />
          <motion.circle
            cx={cx} cy={cy} r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            initial={{ strokeDashoffset: circumference }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1.4, ease: 'easeOut', delay: 0.2 }}
          />
        </svg>
        <Box sx={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}>
          <Typography sx={{ fontWeight: 800, fontSize: size > 70 ? '1.1rem' : '0.8rem', color, lineHeight: 1 }}>
            {score}
          </Typography>
          <Typography sx={{ fontSize: '0.5rem', color: '#9ca3af', fontWeight: 600 }}>/100</Typography>
        </Box>
      </Box>
      {label && (
        <Typography sx={{ fontSize: '0.65rem', color: '#6b7280', fontWeight: 500, mt: 0.5, textAlign: 'center' }}>
          {label}
        </Typography>
      )}
    </Box>
  );
}

export default ScoreRing;
